import Navbar from "components/Navbar"
import React from "react";
import Footer from "components/Footer";
import ProgramList from "components/Program/ProgramList";
import { useSelector } from "react-redux";
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import { useEffect } from "react";



function Program () {

    const isMobile = useSelector(state => state.windowSize.isMobile);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <ProgramList/>
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <ProgramList/>
            <Footer />
            </>
        )}
        </>
    )
}

export default Program